import React, { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { Row, Skeleton } from "antd";
import moment from "moment";

import summaryApi from "../../apis/Summary.api";

import { negativeColor, positiveColor } from "./BannerAlgorithm";

const TodayTraffic = () => {
	const user = useSelector((state) => state.auth.user);
	const [loading, setLoading] = useState(false);

	const [userMoveValue, setUserMoveValue] = useState({
		inflow: 0,
		signup: 0,
		compare_inflow: 0,
		compare_avg_inflow: 0,
	});

	const [compareList, setCompareList] = useState([
		{
			name: "좋아요",
			count: 0,
			condition: 0,
		},
		{
			name: "댓글",
			count: 0,
			condition: 0,
		},
		{
			name: "조회수",
			count: 0,
			condition: 0,
		},
	]);
	const [dataChart, setDataChart] = useState([]);

	const options = {
		responsive: true,
		// aspectRatio: 0.1,
		maintainAspectRatio: false,
		legend: {
			position: "top",
			align: "center",
			display: false,
		},
		labels: {
			display: false,
		},
		tooltips: {
			intersect: false,
			callbacks: {
				label: function (tooltipItem, data) {
					let value = data.datasets[0].data[tooltipItem.index];
					return value.toLocaleString() + "회";
				},
			},
		},
		scales: {
			yAxes: [
				{
					scaleLabel: {
						display: false,
					},
					ticks: {
						display: false, // it should work
					},
					// ticks: {
					//     userCallback: function(value, index, values) {
					//         return value.toLocaleString();
					//     }
					// },
					gridLines: {
						display: false,
					},
				},
			],
			xAxes: [
				{
					gridLines: {
						display: false,
					},
				},
			],
		},
	};

	const data = {
		labels: dataChart?.length
			? dataChart?.map((item) => moment(item.create_date).format("MM/DD"))
			: [],
		datasets: [
			{
				// label: '댓글',
				data: dataChart?.length
					? dataChart?.map((item) => item.inflow_num)
					: [],
				borderColor:
					userMoveValue?.compare_inflow > 0 ? positiveColor : negativeColor,
				backgroundColor:
					userMoveValue?.compare_inflow > 0
						? "rgba(53, 162, 235, 0.1)"
						: "rgba(223, 29, 29, 0.1)",
				borderWidth: 2,
			},
		],
	};

	useEffect(() => {
		if (user?.id) {
			const timer = setTimeout(() => {
				getUserThatTime();
			}, 100);
			return () => clearTimeout(timer);
		}
		return () => {
			setLoading(false);
		};
	}, [user]);

	const getUserThatTime = async () => {
		setLoading(true);
		const weeklyParam = {
			userId:
				user?.role === "level_1" || user?.role === "super_admin"
					? user?.id
					: user?.partners_id,
			startDate: moment()
				.subtract(1, "weeks")
				.startOf("days")
				.format("YYYYMMDDHHmm"),
			endDate: moment().endOf("days").format("YYYYMMDDHHmm"),
			dateType: "weekly",
		};

		const res = await summaryApi.readDashboardUserThatTime(weeklyParam);
		if (res.code === 200) {
			let list = res.result?.userSummaryList;
			setDataChart(list);

			let now = list[list.length - 1];
			let before = list[list.length - 2];

			const hour = new Date().getHours();

			setUserMoveValue({
				inflow: now?.inflow_num ?? 0,
				signup: now?.signup_num ?? 0,
				compare_inflow: now?.inflow_num - before?.inflow_num ?? 0,
				compare_avg_inflow: hour
					? now?.inflow_num - Math.floor(before.inflow_num / (24 / hour))
					: now?.inflow_num - before?.inflow_num,
			});

			setCompareList([
				{
					name: "좋아요",
					count: now?.favorite_num,
					condition: now?.favorite_num - before?.favorite_num ?? 0,
				},
				{
					name: "댓글",
					count: now?.comment_num,
					condition: now?.comment_num - before?.comment_num ?? 0,
				},
				{
					name: "조회수",
					count: now?.view_num,
					condition: now?.view_num - before?.view_num ?? 0,
				},
			]);
		}
		setLoading(false);
	};

	return (
		<div className={`dashboard-component`}>
			<h3>금일 유입량 / 활동</h3>
			<div className={`dashboard-component-chart-bottom`}>
				<div className={`dashboard-big-price-div`}>
					{/* 금일 유입량 표기 */}
					<div className={`dashboard-point-with-img-div`}>
						<Skeleton
							loading={loading}
							active={loading}
							size={"large"}
							block={true}
							className={`skeleton-point-price`}
							style={{
								height: "6em",
							}}
							title={null}
							paragraph={{
								rows: 3,
								width: "100%",
							}}
						>
							<div
								style={{
									display: "flex",
									alignItems: "baseline",
									gap: 5,
								}}
							>
								<h1>{userMoveValue?.inflow?.toLocaleString()}</h1>
								<b>회</b>
								<img
									src={`/assets/images/dashboard/${
										userMoveValue?.compare_avg_inflow > 0
											? "blue-up"
											: userMoveValue?.compare_avg_inflow < 0
											? "red-down"
											: "middle"
									}.png`}
									alt={`대시보드 경고 아이콘`}
									style={{
										width: "1.8em",
										height: "1.8em",
										marginLeft: 5,
									}}
								/>
							</div>
							<p className={`dark-gray`}>
								어제 시간대 평균 대비
								<span
									style={{
										color:
											userMoveValue?.compare_avg_inflow > 0
												? // ? "#df1d1d"
												  positiveColor
												: userMoveValue?.compare_avg_inflow < 0
												? // ? "#117ffb"
												  negativeColor
												: "inherit",
									}}
								>
									{" "}
									{Math.abs(
										userMoveValue?.compare_avg_inflow
									)?.toLocaleString()}
									회 {userMoveValue?.compare_avg_inflow >= 0 ? "증가" : "감소"}
								</span>
							</p>
						</Skeleton>
					</div>

					{/* 좋아요, 댓글, 조회수 - mobile-hidden */}
					<div className={`dashboard-point-with-img-div point-list`}>
						<Skeleton
							loading={loading}
							active={loading}
							size={"large"}
							block={true}
							style={{
								height: "6em",
								paddingLeft: "1.2em",
							}}
							title={null}
							paragraph={{
								rows: 3,
								width: "100%",
							}}
						>
							{compareList?.map((item, idx) => (
								<div
									style={{
										display: "flex",
										justifyContent: "space-between",
										alignItems: "center",
										width: "100%",
										padding: "0.5em 0 0.5em 1.2em",
									}}
									key={`dashboard-today-${idx}`}
								>
									<p className={`dark-gray`}>{item.name}</p>
									<div style={{ display: "flex", alignItems: "center" }}>
										<p>{item.count?.toLocaleString()}</p>
										<img
											src={`/assets/images/dashboard/${
												item?.condition > 0
													? "up"
													: item?.condition < 0
													? "down"
													: "middle"
											}.png`}
											alt={`대시보드 경고 아이콘`}
											style={{
												width: "1.1em",
												height: "1.1em",
												marginLeft: 6,
											}}
										/>
									</div>
								</div>
							))}
						</Skeleton>
					</div>
				</div>
			</div>

			<div
				className={`border-top my-line-chart-user-div`}
				style={{
					position: "relative",
					width: "100%",
					maxHeight: "16rem",
					padding: "1.5em 0 0",
				}}
			>
				{loading ? (
					<Skeleton.Button
						loading={loading}
						active={loading}
						size={"large"}
						block={true}
						style={{
							height: "18vh",
						}}
						title={null}
					/>
				) : (
					<Line options={options} data={data} />
				)}
				{!dataChart?.length && !loading && (
					<Row
						align={"middle"}
						style={{
							width: "100%",
							flexDirection: "column",
							padding: "3em 0",
							position: "absolute",
							top: "50%",
							left: "50%",
							transform: "translate(-50%, -50%)",
							height: "100%",
							justifyContent: "center",
						}}
					>
						<img
							src={`/assets/images/warning.png`}
							alt={`warning-icon`}
							style={{
								width: "3em",
								height: "auto",
							}}
						/>
						<p
							style={{
								marginTop: "1em",
								color: "#adb5bd",
								fontSize: "1.1em",
								fontWeight: 500,
							}}
						>
							금일 유입량/활동 내역이 없습니다.
						</p>
					</Row>
				)}
			</div>

			{/* 좋아요, 댓글, 조회수 - mobile-show */}
			<div
				className={`dashboard-point-with-img-div point-list point-list-mobile`}
			>
				<Skeleton
					loading={loading}
					active={loading}
					size={"large"}
					block={true}
					style={{
						height: "6em",
						paddingTop: "1.2em",
					}}
					title={null}
					paragraph={{
						rows: 3,
						width: "100%",
					}}
				>
					{compareList?.map((item, idx) => (
						<div
							style={{
								display: "flex",
								justifyContent: "space-between",
								alignItems: "center",
								width: "100%",
								padding: "0.5em 0",
							}}
							key={`dashboard-today-${idx}`}
						>
							<p className={`dark-gray`}>{item.name}</p>
							<div style={{ display: "flex", alignItems: "center" }}>
								<p>{item.count?.toLocaleString()}</p>
								<img
									src={`/assets/images/dashboard/${
										item?.condition > 0
											? "up"
											: item?.condition < 0
											? "down"
											: "middle"
									}.png`}
									alt={`대시보드 경고 아이콘`}
									style={{
										width: "1.1em",
										height: "1.1em",
										marginLeft: 6,
									}}
								/>
							</div>
						</div>
					))}
				</Skeleton>
			</div>

			<div className={`dashboard-component-footer`}>
				<Link to={`/user_manage`} className={`dashboard-footer-font`}>
					회원관리로 이동
				</Link>
			</div>
		</div>
	);
};

export default TodayTraffic;
